import React, { useState } from "react";
import logo from "../../resource/7.png";
import useFormHandler from "../../Hook/useFormHandler";

const GeneralForm = () => {
  const initialValues = {
    // Enquiry Information
    enquiry_type: "",
    enquiry_description: "",
    
    // Personal Information
    full_name: "",
    email_address: "",
    contact_number: "",
    
    ip_address: ""
  };

  const validations = {
    // Enquiry Information
    enquiry_type: {
      required: true,
      validate: (value) =>
        ["general_enquiry", "complaint_feedback", "retreat_information", "donation_inquiry", "volunteer_opportunity"].includes(value) || 
        "Please select a valid enquiry type",
    },
    enquiry_description: {
      required: true,
      minLength: 10,
      message: "Please provide at least 10 characters describing your enquiry",
    },
    
    // Personal Information
    full_name: {
      required: true,
      pattern: /^[A-Za-z\s\-\.]+$/,
      message: "Full name should contain only letters, spaces, hyphens, or periods",
    },
    email_address: {
      required: true,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Invalid email format",
    },
    contact_number: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "Contact Number should be 10 to 15 digits, with optional '+'",
    },
  };

  const endpoint = '/create-general-enquiries';

  const transformForApi = (data) => ({
    // Enquiry Information
    enquiry_type: data.enquiry_type,
    enquiry_description: data.enquiry_description,
    
    // Personal Information
    full_name: data.full_name,
    email_address: data.email_address,
    contact_number: data.contact_number,
    
    ip_address: data.ip_address,
  });

  const {
    formData,
    errors,
    loading,
    handleInputChange,
    handleSubmit,
    setFormData,
  } = useFormHandler({
    initialValues,
    validations,
    endpoint,
    includeIP: true,
    transformFn: transformForApi
  });

  return (
    <div className="form-page dark-gold">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="Monastery Logo" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">General Enquiries</h2>
          </div>
        </div>
        
        <p className="font-p mt-6">
          Submit your enquiry and we will respond to you shortly.
        </p>
        
        <p className="font-p mt-5">
          What type of enquiry do you have? (Required)*
        </p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <select
              id="enquiry_type"
              name="enquiry_type"
              value={formData.enquiry_type}
              onChange={handleInputChange}
              style={{ padding: "6px", borderRadius: "4px", width: "100%" }}
            >
              <option value="">Select enquiry type</option>
              <option value="general_enquiry">General enquiry</option>
              <option value="complaint_feedback">Complaint or feedback</option>
              <option value="retreat_information">Retreat Information</option>
              <option value="donation_inquiry">Donation Inquiry</option>
              <option value="volunteer_opportunity">Volunteer Opportunity</option>
            </select>
            <label htmlFor="enquiry_type">Enquiry Type</label>
            {errors.enquiry_type && <span className="error">{errors.enquiry_type}</span>}
          </div>
        </div>
        
        <p className="font-p mt-5">
          What best describes your enquiry? (Required)*
        </p>
        <div className="form-item mt-4">
          <textarea
            id="enquiry_description"
            name="enquiry_description"
            value={formData.enquiry_description}
            onChange={handleInputChange}
            rows="6"
          />
          {errors.enquiry_description && <span className="error">{errors.enquiry_description}</span>}
        </div>
        
        <p className="font-p mt-5">Full name (Required)*</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="text"
              id="full_name"
              name="full_name"
              value={formData.full_name}
              onChange={handleInputChange}
            />
            <label htmlFor="full_name">Full Name</label>
            {errors.full_name && <span className="error">{errors.full_name}</span>}
          </div>
        </div>
        
        <p className="font-p mt-5">Email address (Required)*</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="email"
              id="email_address"
              name="email_address"
              value={formData.email_address}
              onChange={handleInputChange}
            />
            <label htmlFor="email_address">Email Address</label>
            {errors.email_address && <span className="error">{errors.email_address}</span>}
          </div>
        </div>
        
        <p className="font-p mt-5">Contact Number (Required)*</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="text"
              id="contact_number"
              name="contact_number"
              value={formData.contact_number}
              onChange={handleInputChange}
            />
            <label htmlFor="contact_number">Contact Number</label>
            {errors.contact_number && <span className="error">{errors.contact_number}</span>}
          </div>
        </div>
        
        <p className="font-p mt-5">
          We warmly welcome your inquiries and feedback regarding your
          experience with our monastery and the services we provide.
        </p>
        
        <button
          type="submit"
          id="submitbtn"
          className="mt-5"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
        
        <p className="font-p mt-4">
          Your input is invaluable to us, as it allows us to monitor and enhance
          our services for the benefit of our Sangha, our Monastery, and the
          supporting community members.
        </p>
      </form>
    </div>
  );
};

export default GeneralForm;